import React from 'react';
import { GoogleLogin } from 'react-google-login';
import gIcon from '../assets/img/google-icon.png';
import makeCancelable from '../helpers/PromiseWrapper';
import { getCsrfToken, handleCsrfFailure } from '../helpers/GetCsrfToken';

export default class FacebookLogin extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: false
    };
    this.requests = [];
  }

  componentWillUnmount() {
    for (let i = 0; i < this.requests.length; i++) {
      this.requests[i].cancel();
    }
  }

  handleResponse = googleUser => {
    this.setState({
      loading: true
    });
    var profile = googleUser.getBasicProfile();
    let userId = profile.getId();
    let emailAddress = profile.getEmail();
    var authResponse = googleUser.getAuthResponse();
    if (!!authResponse) {
      var id_token = authResponse.id_token;
      let request = makeCancelable(
        fetch('api/Customer/SocialLogin', {
          method: 'post',
          headers: {
            Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-XSRF-TOKEN': getCsrfToken()
          },
          body: JSON.stringify({
            provider: 'google',
            accessToken: id_token,
            userId,
            emailAddress
          })
        })
      );
      this.requests.push(request);
      request
        .then(response => {
          if (response.status === 200) {
            response.json().then(responseData => {
              if (
                !!responseData.customerSessionToken &&
                responseData.customerSessionToken.pizzaExpressId > 0
              ) {
                this.setState({
                  loading: false
                });
                this.props.handleLogin(responseData);
              } else {
                this.setState({
                  loading: false
                });
                // let firstName = profile.getGivenName();
                // let lastName = profile.getFamilyName();
                var profile = {
                  // firstName,
                  // lastName,
                  emailAddress
                };
                this.props.goToRegister(profile);
              }
            });
            } else if (response.status === 400) {
            handleCsrfFailure();
        }
        })
        .catch(error => {
          this.setState({ loading: false });
          console.error(error);
        });
    } else {
      this.setState({
        loading: false
      });
    }
  };

  handleError = error => {
    console.error(error);
    this.setState({ loading: false });
  };

  render() {
    const mainText =
      this.state.loading === true ? 'Logging in...' : 'Log in with Google';
    return (
      <GoogleLogin
        clientId="435702238358-0mgu62nq3ksl14fj8v9iblvgm9m2uti7.apps.googleusercontent.com"
        render={renderProps => (
          <button
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
            className="btn btn-secondary social-login google"
          >
            <img src={gIcon} alt="google icon" />
            {mainText}
          </button>
        )}
        buttonText="Login"
        onSuccess={this.handleResponse}
        onFailure={this.handleError}
        cookiePolicy={'single_host_origin'}
      />
    );
  }
}
